import React, {useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';

import {Heading, Text} from '@edume/magnificent';

import Container from '../../../components/ManagerInsights/Container';
import ContentDetailCard from '../../../components/ManagerInsights/ContentDetailCard';
import EmptyState from '../../../components/ManagerInsights/EmptyState';
import Header from '../../../components/ManagerInsights/Header';
import SearchBar from '../../../components/ManagerInsights/SearchBar';
import SearchContainer from '../../../components/ManagerInsights/SearchContainer';
import Tabs from '../../../components/ManagerInsights/Tabs';
import * as managerInsightsActions from '../../../state/managerInsights/managerInsightsActions';
import {getManagerInsightsByStore} from '../../../state/managerInsights/managerInsightsSelector';
import {formatedDateString} from '../../../utils/managerInsightUtils';

import managerInsightsStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const mapStateToProps = (state, ownProps) => {
  const {cid, insightId, managerId} = ownProps.match.params;
  const managerInsightsByStore = getManagerInsightsByStore(state);
  const contents = managerInsightsByStore.get('contents').toJS();
  const users = managerInsightsByStore.get('users').toJS();
  const content = contents.find((contentPar) => contentPar.id === Number(cid));

  const {completedUsers, noneCompletedUsers} = users
    .filter((user) => user.activated)
    .reduce(
      // eslint-disable-next-line no-shadow
      ({completedUsers, noneCompletedUsers}, currentUser) => {
        const completionDate = content.completedUsers[`${currentUser.id}`];
        if (completionDate) {
          return {
            completedUsers: [
              ...completedUsers,
              {...currentUser, completionDate},
            ],
            noneCompletedUsers,
          };
        } else {
          return {
            completedUsers,
            noneCompletedUsers: [...noneCompletedUsers, currentUser],
          };
        }
      },
      {completedUsers: [], noneCompletedUsers: []}
    );

  return {
    // Don't need selector for details information
    details: state.managerInsights.getIn(['insights', 'details']).toJS(),
    content,
    completedUsers,
    noneCompletedUsers,
    insightId,
    managerId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

function ContentDetail({
  goToManagerInsightsAssignedTraining,
  content,
  completedUsers,
  noneCompletedUsers,
  managerId,
  insightId,
}) {
  const [keyword, setKeyword] = useState('');
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    if (!searchMode) {
      setKeyword('');
    }
  }, [searchMode]);

  return (
    <>
      <div className={managerInsightsStyles.view}>
        <div className={managerInsightsStyles.content}>
          <Header
            title={'Training details'}
            onClickBack={() =>
              goToManagerInsightsAssignedTraining({managerId, insightId})
            }
          />
          <Container>
            <div
              styleName='content'
              style={{display: searchMode ? 'none' : 'flex'}}
            >
              {content.image && (
                <div styleName='content-image'>
                  <img src={content.image} width='64' alt='' />
                </div>
              )}
              {content.icon && (
                <div styleName='content-image icon'>
                  <img
                    width={50}
                    src={`https://edume-res.cloudinary.com/image/upload/course_icons/transparent/${content.icon}.png`}
                    alt=''
                  />
                </div>
              )}
              <div styleName='content-text'>
                {content.publishedAt && (
                  <Text
                    colour='textSecondary'
                    inline='false'
                    lineHeight='tight'
                    size='s'
                    textTransform='none'
                    weight='regular'
                  >
                    Published{' '}
                    <strong>{formatedDateString(content.publishedAt)}</strong>
                  </Text>
                )}
                <Heading
                  as='h2'
                  colour='textPrimary'
                  size='hamster'
                  textTransform='none'
                  weight='semiBold'
                >
                  {content.title}
                </Heading>
              </div>
            </div>

            <SearchBar
              value={keyword}
              onChange={setKeyword}
              isModeSearch={searchMode}
              onModeChange={setSearchMode}
            />

            {searchMode ? (
              <SearchContainer
                data={[...noneCompletedUsers, ...completedUsers]}
                keyword={keyword}
                type={'user'}
                searchField={'name'}
                rowRender={(user) => (
                  <ContentDetailCard
                    key={user.id}
                    name={user.name}
                    isCompleted={!!user.completionDate}
                    isInSearch
                  />
                )}
              />
            ) : (
              <Tabs
                layz
                items={[
                  {
                    id: '1',
                    title: 'Not Completed',
                    count: noneCompletedUsers.length,
                    content: (
                      <>
                        {noneCompletedUsers.map((user) => (
                          <ContentDetailCard key={user.id} name={user.name} />
                        ))}

                        {!noneCompletedUsers.length && (
                          <EmptyState
                            type='user'
                            title='User not found'
                            description='There is no user in your team'
                          />
                        )}
                      </>
                    ),
                  },
                  {
                    id: '2',
                    title: 'Completed',
                    count: completedUsers.length,
                    content: (
                      <>
                        {completedUsers.map((user) => (
                          <ContentDetailCard key={user.id} name={user.name} />
                        ))}

                        {!completedUsers.length && (
                          <EmptyState
                            type='user'
                            title='User not found'
                            description='There is no user in your team'
                          />
                        )}
                      </>
                    ),
                  },
                ]}
              />
            )}
          </Container>
        </div>
      </div>
    </>
  );
}

ContentDetail.propTypes = {
  insightId: PropTypes.string.isRequired,
  managerId: PropTypes.string.isRequired,
  goToManagerInsightsAssignedTraining: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  completedUsers: PropTypes.array.isRequired,
  noneCompletedUsers: PropTypes.array.isRequired,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(CSSModules(ContentDetail, styles, {allowMultiple: true})))
);
